// extracted by mini-css-extract-plugin
export default {"footer":"AuthFooter_footer__lamnw","containerFooter":"AuthFooter_containerFooter__3esfO"};